
export const DEFAULT_LOGIN_PAGE_DETAILS = {

    name: 'elms',
    logoPath: '/735/Banner/logo-3.png',
    code: 'elms',
    organisationId: '00'
};



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/assets/objects/default-login-object.ts